// src/Notification.js
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Notification.css';
import logo from '../../images/logo-bg.png'; // Add your own logo or icon

const Notification = () => {
  const notify = () => {
    toast.info(
      <div className="custom-toast-content">
        <img src={logo} alt="25 Years of Excellence" className="custom-toast-image" />
        <div className="custom-toast-text">Celebrating 25 Years of Excellence!</div>
      </div>,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        closeButton: false
      }
    );
  };

  React.useEffect(() => {
    notify();
  }, []);

  return <ToastContainer />;
};

export default Notification;
